export default __webpack_public_path__ + "static/media/Feedback.b9ef8084.svg";